import request from '../utils/request'

const prefix = '/api/v1/back'
 /**
 * 笔记管理素材评论列表
 * @param {*} query
 */

export const materialList= (query) => {
  return request({
    url: `${prefix}/note/comment/material/list`,
     method: 'get',
    params: query
  })
}

 /**
 * 获取分组列表
 * @param {*} query
 */
export const categoryList= (query) => {
  return request({
    url: `${prefix}/note/comment/material/category/list`,
     method: 'get',
    params: query
  })
}
 /**
 * 创建素材评论表
 * @param {*} query
 */
export const Creatematerial= (query) => {
  return request({
    url: `${prefix}/note/comment/material/bulk`,
     method: 'post',
    data: query
  })
}
 /**
 * 编辑素材评论表
 * @param {*} query
 */
export const Putmaterial= (query) => {
  return request({
    url: `${prefix}/note/comment/material`,
     method: 'put',
    data: query
  })
}
 /**
 * 删除素材评论表
 * @param {*} query
 */
export const Deletematerial= (query) => {
  return request({
    url: `${prefix}/note/comment/material/list`,
     method: 'delete',
    data: query
  })
}
 /**
 * 新建分组
 * @param {*} query
 */
export const CreatCategory= (query) => {
  return request({
    url: `${prefix}/note/comment/material/category/bulk`,
     method: 'post',
    data: query
  })
}
/**
 * 编辑分组
 * @param {*} query
 */
export const PutCategory= (query) => {
  return request({
    url: `${prefix}/note/comment/material/category`,
     method: 'put',
    data: query
  })
}
/**
 * 删除分组
 * @param {*} query
 */
export const DeleteCategory= (query) => {
  return request({
    url: `${prefix}/note/comment/material/category/list`,
     method: 'delete',
    data: query
  })
}







